import {formatDate as fmt} from '@angular/common';
import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../types/iso-date';

export function formatTime(date: IsoDate | IsoDateTime | IsoDateTimeTz): string {
  return fmt(date, 'yyyy-MM-dd', 'en-US');
}
